module.exports = __webpack_public_path__ + "static/peppers-8ad0bf11b513cd62b3ff9636be9ab082.jpg";